import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import {
  Row,
  Col,
  Divider,
  Skeleton,
  Button,
  Checkbox,
  Drawer,
  Modal,
  message,
} from "antd";
import { gql, useLazyQuery, useMutation } from "@apollo/client";
import moment from "moment-jalaali";
import UserContract from "@general/userContract";
import DatePicker from "@general/datePicker";
import SafeHtml from "@general/safeHtml";
import { useNavigate } from "react-router-dom";

const WsSinglePackage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [packageDetails, setPackageDetails] = useState();
  const [contractChekBox, SetContractChekbox] = useState(false);
  const [userContractDrawer, setUserContractDrawer] = useState(false);
  const [startDate, setStartDate] = useState(null);

  const GETPACKAGE = gql`
    query ($id: ID!) {
      getPackage(id: $id) {
        name
        description
        packageType
        product {
          name
          id
        }
        days
        sessions
        amountRial
        strikethroughRial
        contract
      }
    }
  `;

  const REQUESTWORKSPACE = gql`
    mutation ($productId: ID!, $packageId: ID!, $startAt: DateTime) {
      createWorkSpaceInvoice(productId: $productId, packageId: $packageId, startAt: $startAt) {
        id
      }
    }
  `;

  const [getPackageData, packageData] = useLazyQuery(GETPACKAGE, {
    fetchPolicy: "no-cache",
    onCompleted({ getPackage }) {
      const {
        name,
        packageType,
        product,
        description,
        days,
        sessions,
        amountRial,
        strikethroughRial,
        contract,
      } = getPackage;
      const packageData = {
        name,
        packageType,
        product,
        description,
        days,
        sessions,
        amountRial,
        strikethroughRial,
        contract,
      };
      setPackageDetails(packageData);
    },
  });
  const [runRequestWorkSpace, requestWorkSpace] = useMutation(
    REQUESTWORKSPACE,
    {
      onError(err) {
        Modal.error({
          title: err.message,
          okText: "باشه",
        });
      },
      onCompleted(data) {
        navigate(`/invoice/${data.createWorkSpaceInvoice.id}`);
      },
    }
  );
  useEffect(() => {
    if (id) {
      getPackageData({
        variables: {
          id,
        },
      });
    }
  }, [id]);

  const openContractDrawer = () => {
    setUserContractDrawer(true);
  };
  const createInvoice = () => {
    if (startDate) {
      const today = moment().startOf("day");
      const maxDate = moment().add(1, "jMonth").endOf("day");
      if (startDate.isBefore(today) || startDate.isAfter(maxDate)) {
        message.error("تاریخ شروع انتخابی باید بین امروز تا یک ماه تقویمی آینده باشد");
        return;
      }
    }
    runRequestWorkSpace({
      variables: {
        productId: packageDetails?.product?.id,
        packageId: id,
        startAt: startDate ? startDate.toDate() : null,
      },
    });
  };

  const displayContract = packageDetails?.contract
    ? packageDetails.contract
        .replace(
          /START_DATE/g,
          startDate
            ? moment(startDate).format("jYYYY/jMM/jDD")
            : moment().format("jYYYY/jMM/jDD")
        )
        .replace(
          /END_DATE/g,
          packageDetails.days
            ? moment(startDate ? startDate : undefined)
                .add(packageDetails.days, "day")
                .format("jYYYY/jMM/jDD")
            : ""
        )
    : "";

  return (
    <Row justify="center" align="middle" style={{ height: "100%" }}>
      {packageDetails?.contract && (
        <Drawer
          title={"تعهدنامه استفاده از فضای کار"}
          placement="top"
          open={userContractDrawer}
          onClose={() => setUserContractDrawer(false)}
          height={300}
        >
          <UserContract
            contract={displayContract}
            onCloseDrawer={() => setUserContractDrawer(false)}
          />
        </Drawer>
      )}

      <div
        className={`${
          packageData.loading
            ? "single-package-wrapper-loading"
            : "single-package-wrapper"
        }`}
      >
        {packageData.loading ? (
          <>
            <Skeleton active round />
            <Skeleton active round />
          </>
        ) : (
          <>
            <div className="single-package-name">{packageDetails?.name}</div>
            {packageDetails?.description && (
              <>
                <Divider orientation="right">توضیحات</Divider>
                <SafeHtml
                  content={packageDetails.description}
                  className="single-package-description"
                />
              </>
            )}
            <Divider orientation="right">مشخصات</Divider>
            <div className="single-package-details">
              <Row gutter={20} style={{ width: "100%" }}>
                <Col xs={12}>
                  <div className="single-package-duration">
                    <span>مدت زمان: </span>
                    <span>{packageDetails?.days + " روز"}</span>
                  </div>
                </Col>
                <Col xs={12}>
                  <div className="package-price-wrapper single-package-price">
                    {packageDetails?.strikethroughRial && (
                      <div className="package-strikethrough-wrapper">
                        <span>
                          {(
                            packageDetails?.strikethroughRial / 10
                          ).toLocaleString()}{" "}
                          تومان
                        </span>
                        <span className="package-strikethrough"></span>
                      </div>
                    )}

                    <span className="amount">
                      {(packageDetails?.amountRial / 10).toLocaleString()} تومان
                    </span>
                  </div>
                </Col>
              </Row>

              <Row gutter={20} style={{ width: "100%", marginTop: 15 }}>
                <Col xs={24} md={12}>
                  <div style={{ marginBottom: 6, fontWeight: 500, fontSize: "13px" }}>
                    تاریخ شروع پکیج (اختیاری):
                  </div>
                  <DatePicker
                    style={{ width: "100%" }}
                    format="jYYYY/jMM/jDD"
                    placeholder="انتخاب تاریخ شروع (پیش‌فرض: امروز)"
                    value={startDate}
                    onChange={(date) => setStartDate(date)}
                    disabledDate={(current) => {
                      if (!current) return false;
                      const today = moment().startOf("day");
                      const maxDate = moment().add(1, "jMonth").endOf("day");
                      return current.isBefore(today) || current.isAfter(maxDate);
                    }}
                  />
                </Col>
                <Col xs={24} md={12}>
                  <div style={{ marginTop: 24, fontSize: "12px", color: "#555" }}>
                    <span>تاریخ پایان پیش‌بینی‌شده: </span>
                    <strong style={{ color: "#1890ff" }}>
                      {packageDetails?.days
                        ? moment(startDate ? startDate : undefined)
                            .add(packageDetails.days, "day")
                            .format("jYYYY/jMM/jDD")
                        : "نامشخص"}
                    </strong>
                  </div>
                </Col>
              </Row>

              {packageDetails?.contract && (
                <Row style={{ marginTop: 20 }}>
                  <Checkbox
                    checked={contractChekBox}
                    onChange={() => SetContractChekbox(!contractChekBox)}
                  >
                    <div className="single-package-contract-checkbox">
                      <Button
                        type="link"
                        style={{ fontWeight: "bold" }}
                        onClick={openContractDrawer}
                      >
                        تعهدنامه
                      </Button>
                      مربوط به استفاده از فضای کار صفاتک را مطالعه کرده و شرایط
                      آن را قبول میکنم.
                    </div>
                  </Checkbox>
                </Row>
              )}
            </div>

            <Button
              type="primary"
              className="single-package-btn"
              disabled={packageDetails?.contract ? !contractChekBox : false}
              onClick={() => createInvoice()}
            >
              خرید
            </Button>
          </>
        )}
      </div>
    </Row>
  );
};

export default WsSinglePackage;
